import React from "react";
import PropTypes from "prop-types";

import Grid from "core/Grid";

import {
    PromoBoxLink,
    IconContainer,
    Title,
    Description,
    LearnMore,
    LearnMoreIcons,
    LearnMorePseudoLink
} from "./styles";

const LearnMoreBox = ({ learnMoreContent }) => {
    if (typeof learnMoreContent === "string") {
        // if learnMoreContent is just text:
        return (
            <LearnMore>
                <LearnMorePseudoLink>{learnMoreContent}</LearnMorePseudoLink>
            </LearnMore>
        );
    } else {
        // if learnMoreContent is an array of SVG icons:
        return (
            <LearnMoreIcons>
                {learnMoreContent.map((learnMoreIcon, index) => {
                    const { icon } = learnMoreIcon;

                    return <React.Fragment key={index}>{icon}</React.Fragment>;
                })}
            </LearnMoreIcons>
        );
    }
};

const PromoBoxes = ({ content }) => {
    return (
        <Grid
            mobileSpacing={20}
            tabletSpacing={20}
            desktopSpacing={20}
            justifyContent="center"
        >
            {content.map(promo => {
                const {
                    url,
                    iconName,
                    title,
                    description,
                    learnMoreContent
                } = promo;

                return (
                    <Grid item sm={12} md={6} lg={4} key={title}>
                        <PromoBoxLink href={url}>
                            <IconContainer>{iconName}</IconContainer>
                            <Title>{title}</Title>
                            <Description>{description}</Description>
                            <LearnMoreBox learnMoreContent={learnMoreContent} />
                        </PromoBoxLink>
                    </Grid>
                );
            })}
        </Grid>
    );
};

PromoBoxes.propTypes = {
    content: PropTypes.array.isRequired
};

export default PromoBoxes;
